import { useState } from "react";
import { Smartphone, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePwaInstall } from "@/pwa/usePwaInstall";
import { IOSInstallDialog } from "@/components/pwa/IOSInstallDialog";
import { AndroidInstallDialog } from "@/components/pwa/AndroidInstallDialog";

export const InstallSettings = () => {
  const { canInstall, iosEligible, androidFallback, isStandalone, installed, promptInstall } = usePwaInstall();
  const [iosOpen, setIosOpen] = useState(false);
  const [androidOpen, setAndroidOpen] = useState(false);
  const isInstalled = isStandalone || installed;

  return (
    <section className="rounded-2xl border border-border bg-card p-5" data-testid="install-settings">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-head text-lg font-bold flex items-center gap-2"><Smartphone className="h-5 w-5 text-primary" />App sul dispositivo</h2>
      </div>

      {isInstalled ? (
        <div className="flex items-center gap-2 text-sm text-[#1E5E2B] font-semibold" data-testid="install-state-installed">
          <CheckCircle2 className="h-4 w-4" /> K9 Manager è installato su questo dispositivo
        </div>
      ) : canInstall ? (
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <p className="text-sm text-muted-foreground">Aggiungi K9 Manager alla schermata Home per aprirlo come un’app.</p>
          <Button data-testid="install-settings-cta" className="rounded-full" onClick={() => promptInstall()}>Installa K9 Manager</Button>
        </div>
      ) : iosEligible ? (
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <p className="text-sm text-muted-foreground">Aggiungi K9 Manager alla schermata Home del tuo iPhone o iPad.</p>
          <Button data-testid="install-settings-ios-cta" className="rounded-full" onClick={() => setIosOpen(true)}>Installa K9 Manager</Button>
        </div>
      ) : androidFallback ? (
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <p className="text-sm text-muted-foreground">Aggiungi K9 Manager alla schermata Home per aprirlo come un’app.</p>
          <Button data-testid="install-settings-android-cta" className="rounded-full" onClick={() => setAndroidOpen(true)}>Installa K9 Manager</Button>
        </div>
      ) : (
        <p className="text-sm text-muted-foreground" data-testid="install-state-unsupported">
          L’installazione non è disponibile su questo browser. Apri K9 Manager in Chrome (Android) o Safari (iPhone/iPad) per aggiungerlo alla schermata Home.
        </p>
      )}

      <IOSInstallDialog open={iosOpen} onOpenChange={setIosOpen} />
      <AndroidInstallDialog open={androidOpen} onOpenChange={setAndroidOpen} />
    </section>
  );
};
